module.exports = __webpack_public_path__ + "img/logo.a91d3810.png";